<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[700px] desktop:w-[950px]">
    <OrganismsPanelsElectronicOrder :ware-image-id="dialog?.data.wareImageId" :ware-name="dialog?.data.wareName" :variant-id="dialog?.data.variantId" :variant-name="dialog?.data.variantName" :piece-price="dialog?.data.piecePrice" :unit="dialog?.data.unit" :quantity="dialog?.data.quantity" @close="close" />
  </AtomsGlobalDialog>
</template>
<script setup>

const close = () => useDialog().close();

const dialog = computed(() => useDialog().get('electronicOrder'));

</script>